import { useRootStore } from './useRootStore'

export function useUrlParams() {
  const { rootStore } = useRootStore()

  return rootStore.urlParams
}
